import React from "react";
import './FloatedIcons.css'
import icon1 from '../img/float icon1.png'
import icon2 from '../img/float icon2.png'
import icon3 from '../img/float icon3.png'

export default function FloatedIcons() {
   return (
      <div className='floated-icons' >
         <div className="icon-strip">
            <img src={icon3} alt="icon" />
            <a href='#planeYourVisit'>Visit Plan</a>
         </div>
         <div className="icon-strip">
            <img src={icon2} alt="icon" />
            <a href='#gallery'>Gallery</a>
         </div>
         <div className="icon-strip">
            <img src={icon1} alt="icon" />
            <a href='#library'>Explore</a>
         </div>
      </div>
   )
}
